export function cleanErrors(state) {
  state.error = false
  state.errorMessage = ''
}

export function error(state, payload) {
  state.error = true
  state.errorMessage = payload
}

export function setIsCharging(state, value) {
  state.charging = value
}
